export default __webpack_public_path__ + "images/0xe3f5a90f9cb311505cd691a46596599aa1a0ad7d.png";